import { render, staticRenderFns } from "./NumberFieldOptions.vue?vue&type=template&id=3419b231&scoped=true&lang=pug&"
import script from "./NumberFieldOptions.vue?vue&type=script&lang=ts&"
export * from "./NumberFieldOptions.vue?vue&type=script&lang=ts&"
import style0 from "./NumberFieldOptions.vue?vue&type=style&index=0&id=3419b231&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3419b231",
  null
  
)

export default component.exports